export class ValidatorPatterns {
    //TODO LATER: a szerver oldalról elkérni a validátort
    //source https://emailregex.com/index.html (from Javascript) change EmailValidatorWithJSONMessage._expression on c# side when changes
    public static EMAIL_VALIDATION_PATTERN: RegExp =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
}
